import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { formatDateToUserTimezone } from '../../../common/CustomFormatDate'
import { SHIPPERS } from '../../../constants/contactCategory'
import { Badge } from 'reactstrap'

// Format phone number
const formatPhoneNumber = (phone) => {
  if (!phone) return 'N/A'
  const cleaned = phone.replace(/\D/g, '')
  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`
  }
  return phone
}

// Body renderers
export const directionBody = (rowData) => {
  const isInbound = rowData.direction === 'Inbound'
  return (
    <Badge color={isInbound ? 'info' : 'warning'} style={{ padding: '8px 12px', fontSize: '14px' }}>
      {isInbound ? '📥 In' : '📤 Out'}
    </Badge>
  )
}

export const userBody = (rowData) => {
  if (!rowData.userName) return <div>—</div>
  return <div>{rowData.userName}</div>
}

export const contactLink = (rowData) => {
  const contactClickHandler = (rowData) => {
    let urlPrefix = 'contacts'
    if (rowData?.contactCategory === SHIPPERS) {
      urlPrefix = 'customer-logistics/all-customers'
    }
    window.open(`/${urlPrefix}/${rowData.contact_id}`, '_blank')
  }

  if (!rowData.contactName) return <div>—</div>

  return (
    <Link onClick={() => contactClickHandler(rowData)} rel='noopener noreferrer'>
      {rowData.contactName}
    </Link>
  )
}

export const phoneColumn = (rowData) => {
  const fromNumber = formatPhoneNumber(rowData.fromNumber)
  const toNumber = formatPhoneNumber(rowData.toNumber)

  return (
    <div style={{ fontSize: '13px', lineHeight: '1.6' }}>
      <div>
        <strong>From:</strong> {fromNumber}
      </div>
      <div>
        <strong>To:</strong> {toNumber}
      </div>
    </div>
  )
}

const TextPreviewCell = ({ text }) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const maxLength = 150

  if (!text) {
    return <div>—</div>
  }

  const isTruncated = text.length > maxLength
  const displayText = isExpanded || !isTruncated ? text : text.substring(0, maxLength) + '...'

  return (
    <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
      {displayText}
      {isTruncated && (
        <span
          onClick={(e) => {
            e.stopPropagation()
            setIsExpanded(!isExpanded)
          }}
          style={{
            color: '#007bff',
            cursor: 'pointer',
            marginLeft: '5px',
            textDecoration: 'none',
            fontWeight: '500',
          }}
          onMouseEnter={(e) => (e.target.style.textDecoration = 'underline')}
          onMouseLeave={(e) => (e.target.style.textDecoration = 'none')}
        >
          {isExpanded ? 'Show less' : 'Show more'}
        </span>
      )}
    </div>
  )
}

export const textPreview = (rowData) => {
  return <TextPreviewCell text={rowData.text || ''} />
}

export const dateColumn = (rowData, user) => {
  return <div>{formatDateToUserTimezone(rowData.creationDate, user)}</div>
}

export const statusBody = (rowData) => {
  return (
    <Badge color='secondary' style={{ padding: '6px 10px', fontSize: '13px' }}>
      {rowData.messageStatus}
    </Badge>
  )
}

// Column definitions factory
export const createColumns = ({ user }) => [
  {
    field: 'direction',
    header: 'Direction',
    body: directionBody,
    style: { width: '120px' },
  },
  {
    field: 'users.id',
    header: 'User',
    body: userBody,
    style: { width: '150px' },
  },
  {
    field: 'contact.name',
    header: 'Contact',
    body: contactLink,
    style: { width: '180px' },
  },

  {
    field: 'phoneNumber',
    header: 'From / To',
    body: phoneColumn,
    style: { width: '200px' },
    sortable: false,
  },
  {
    field: 'text',
    header: 'Message',
    body: textPreview,
    style: { minWidth: '250px' },
  },
  {
    field: 'creationDate',
    header: 'Date',
    body: (rowData) => dateColumn(rowData, user),
    style: { width: '180px' },
  },
  {
    field: 'messageStatus',
    header: 'Status',
    body: statusBody,
    style: { width: '120px' },
  },
]
